/* Search page behaviour.

   The reference fires two requests as you type: one for the suggestion list
   and one for the grid beneath it. This does the same with Shopify's own
   endpoints — /search/suggest.json for the list, and a section render of the
   search page itself for the grid — so a shopper never has to press Enter, and
   the page still works with the script blocked because the form is a real GET
   form to /search.

   Nothing here is search-page-specific beyond the selectors: the section owns
   the markup, this owns the fetching. */
(function () {
  var page = document.querySelector('[data-search-page]');
  if (!page) return;

  var form = page.querySelector('[data-search-form]');
  var input = page.querySelector('[data-search-input]');
  var list = page.querySelector('[data-search-suggest]');
  var results = page.querySelector('[data-search-results]');
  var back = page.querySelector('[data-search-back]');
  if (!form || !input) return;

  var SECTION = page.closest('.shopify-section');
  var SECTION_ID = SECTION ? SECTION.id.replace('shopify-section-', '') : null;
  var MIN = 2;
  var DEBOUNCE = 250;

  back &&
    back.addEventListener('click', function () {
      /* Only leave the site's own history — a direct landing has nothing to go
         back to, so fall through to the home page. */
      if (window.history.length > 1) window.history.back();
      else window.location.href = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
    });

  /* ---------------------------------------------------------- suggestions */

  function escapeHtml(s) {
    return s.replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* Wrap the matched run in <strong>, the way the reference weights the part
     you have already typed. Escaped first, so a title containing markup cannot
     inject any. */
  function highlight(title, term) {
    var safe = escapeHtml(title);
    if (!term) return safe;
    var at = title.toLowerCase().indexOf(term.toLowerCase());
    if (at < 0) return safe;
    var before = escapeHtml(title.slice(0, at));
    var hit = escapeHtml(title.slice(at, at + term.length));
    var after = escapeHtml(title.slice(at + term.length));
    return before + '<strong>' + hit + '</strong>' + after;
  }

  function renderSuggestions(products, term) {
    if (!list) return;
    if (!products.length) {
      list.hidden = true;
      list.innerHTML = '';
      return;
    }
    list.innerHTML = products
      .map(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
        var thumb = img
          ? '<img class="search-suggest__thumb" src="' + escapeHtml(img) + '" alt="" width="32" height="32" loading="lazy">'
          : '<span class="search-suggest__thumb"></span>';
        return (
          '<li><a class="search-suggest__item" href="' + escapeHtml(p.url) + '">' +
          thumb +
          '<span class="search-suggest__text">' + highlight(p.title, term) + '</span>' +
          '</a></li>'
        );
      })
      .join('');
    list.hidden = false;
  }

  function fetchSuggestions(term) {
    var url =
      '/search/suggest.json?q=' + encodeURIComponent(term) +
      '&resources[type]=product&resources[limit]=5&resources[options][unavailable_products]=last';
    return fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var products = (json.resources && json.resources.results && json.resources.results.products) || [];
        renderSuggestions(products, term);
      })
      .catch(function () { renderSuggestions([], term); });
  }

  /* -------------------------------------------------------------- results */

  /* Re-render this very section against the new query and lift out only the
     grid, so the field the shopper is typing in is never replaced under them
     (which would drop focus and the caret). */
  function fetchResults(term) {
    if (!results || !SECTION_ID) return Promise.resolve();
    var url = '/search?q=' + encodeURIComponent(term) + '&type=product&section_id=' + SECTION_ID;
    return fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-search-results]');
        if (fresh) results.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  /* ------------------------------------------------------------- wiring */

  var timer = null;
  var last = input.value.trim();

  function run() {
    var term = input.value.trim();
    if (term === last) return;
    last = term;

    if (term.length < MIN) {
      renderSuggestions([], term);
      if (results) results.innerHTML = '';
      history.replaceState(null, '', '/search');
      return;
    }

    history.replaceState(null, '', '/search?q=' + encodeURIComponent(term));
    fetchSuggestions(term);
    fetchResults(term);
  }

  input.addEventListener('input', function () {
    clearTimeout(timer);
    timer = setTimeout(run, DEBOUNCE);
  });

  /* Enter submits the real form, so no preventDefault here — but close the
     suggestion list first so it does not survive the navigation visually. */
  form.addEventListener('submit', function () {
    if (list) list.hidden = true;
  });

  document.addEventListener('click', function (e) {
    if (!list || list.hidden) return;
    if (!page.contains(e.target) || form.contains(e.target)) return;
    list.hidden = true;
  });

  input.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && list) list.hidden = true;
  });

  /* The reference focuses the field on desktop a moment after load. */
  if (window.matchMedia('(min-width: 768px)').matches && !input.value) {
    input.focus({ preventScroll: true });
  }
})();
